import { fetchWarehouseLogs, changePage } from '#action/warehouse/log';
import { ApplianceFilterOptionService, WarehouseFilterOptionService, UserFilterOptionService, ProjectsFilterOptionService, ActionTypeFilterOptionService } from '#service/autocomplete-service/service';
import { uuidv4 } from '#helper';
import { warehouseEventType } from '#type';

const searchProps = {
  type: 'FilterButton',
  name: 'search',
  label: 'Filter events',
  relatedTo: 'warehouse-log',
  id: uuidv4()
};

const applianceComponent = {
  type: 'SelectWithCounter',
  name: 'appliance',
  label: 'Application',
  relatedTo: 'warehouse-log',
  id: uuidv4(),
  fetchOptionsService: ApplianceFilterOptionService,
  searchFields: ['label']
};

const warehouseComponent = {
  type: 'SelectWithCounter',
  name: 'warehouse',
  label: 'Site',
  relatedTo: 'warehouse-log',
  id: uuidv4(),
  fetchOptionsService: WarehouseFilterOptionService,
  searchFields: ['label']
};

const filterUserComponent = {
  type: 'SelectWithCounter',
  name: 'user',
  label: 'Actor',
  relatedTo: 'warehouse-log',
  id: uuidv4(),
  fetchOptionsService: UserFilterOptionService,
  searchFields: ['fullName']
};

const projectSelect = {
  type: 'SelectWithCounter',
  name: 'project',
  label: 'Project',
  relatedTo: 'warehouse-log',
  id: uuidv4(),
  fetchOptionsService: ProjectsFilterOptionService,
  searchFields: ['title']
};

const actionTypeSelect = {
  type: 'SelectWithCounter',
  name: 'event',
  label: 'Action',
  relatedTo: 'warehouse-log',
  id: uuidv4(),
  fetchOptionsService: ActionTypeFilterOptionService,
  optionServiceConfig: { eventTypes: warehouseEventType },
  searchFields: ['label']
};

const filterConfig = {
  disableSync: true,
  customActions: {
    fetchFilterData: fetchWarehouseLogs,
    changePage
  },
  searchProps,
  dateRangeComponent: true,
  components: [
    applianceComponent,
    warehouseComponent,
    filterUserComponent,
    projectSelect,
    actionTypeSelect
  ]
};

export default filterConfig;
